import React, { useRef, useState } from "react";

const TextField = ({
  textArea,
  input,
  unit,
  placeholder,
  name,
  formik,
  handleChange,
  fieldName,
}) => {
  const inputEl = useRef();
  const [blur, setBlur] = useState(false);
  return (
    <div className="textfield">
      {textArea && (
        <>
          <textarea
            ref={inputEl}
            className="textfield__textarea"
            cols="30"
            rows="10"
          />
          <div
            className="textfield__adornment"
            onClick={() => inputEl.current.focus()}
          >
            <span className="textfield__adornment-text">Adornment:</span>
            <span className="textfield__adornment-placeholder">
              Placeholder
            </span>
          </div>
        </>
      )}
      {input && (
        <div
          style={{ direction: "ltr" }}
          className={`textfield__input ${blur && "textfield__input--focused"}`}
          onClick={() => {
            inputEl.current.focus();
          }}
        >
          <input
            ref={inputEl}
            placeholder={placeholder}
            className="textfield__input-field"
            onFocus={() => setBlur(!blur)}
            onBlur={() => setBlur(false)}
            name={name}
            {...formik.getFieldProps({ name })}
            onChange={(e) => {
              formik.handleChange(e);
              handleChange(e, fieldName);
            }}
          />
          <div className="textfield__input-adornment">
            <span className="textfield__adornment-text">{unit}</span>
          </div>
        </div>
      )}
    </div>
  );
};
export default TextField;
